<template>
  <v-layout row wrap>
     <v-flex xs12 md6 >
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_21 == 'availability'">
        <v-container grid-list-md text-xs-center class="pa-0 ma-0">
          <div class="pa-0 ma-0 d-flex align-center">
            <v-flex xs12 md5 class="pb-4 pb-md-0">
              <div v-if="widgetList.length">
                <div v-for="item in widgetList" :key="item.name">
                  <div class="card-title">{{ $t(item.name) }} (%)</div>
                  <v-progress-circular
                    :rotate="360"
                    :size="65"
                    :width="5"
                    :value="item.value"
                    color="#E9952A"
                  >
                    {{ widgetData[item.name] }}
                  </v-progress-circular>
                </div>
              </div>
            </v-flex>
            <v-divider class="custom-divider hidden-sm-and-down" vertical></v-divider>
            <v-divider class="custom-divider hidden-md-and-up" horizontal></v-divider>
            <v-flex xs12 md7>
              <SimpleList :data="metric" />
            </v-flex>
          </div>
        </v-container>
      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_21 == 'carbon_footprint'">
        <div class="body-2 text-xs-center align-items-center carbon-footprint__header">
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2>
          <v-flex>
            <v-layout row wrap justify-center align-center>
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_21 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_21 == 'card_right'"/>
    </v-flex>
     <v-flex xs12 md6>
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_22 == 'availability'">
        <v-container grid-list-md text-xs-center class="pa-0 ma-0">
          <div class="pa-0 ma-0 d-flex align-center">
            <v-flex xs12 md5 >
              <div v-if="widgetList.length">
                <div v-for="item in widgetList" :key="item.name">
                  <div class="card-title">{{ $t(item.name) }} (%)</div>
                  <v-progress-circular
                    :rotate="360"
                    :size="65"
                    :width="5"
                    :value="item.value"
                    color="#E9952A"
                  >
                    {{ widgetData[item.name] }}
                  </v-progress-circular>
                </div>
              </div>
            </v-flex>
            <v-divider class="custom-divider hidden-sm-and-down" vertical></v-divider>
            <v-divider class="custom-divider hidden-md-and-up" horizontal></v-divider>
            <v-flex xs12 md7 class="pa-0">
              <SimpleList :data="metric" />
            </v-flex>
          </div>
        </v-container>
      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_22 == 'carbon_footprint'">
        <div
          class="body-2 text-xs-center"
          :style="{
            height: '61px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2 class="align">
          <v-flex>
            <v-layout row wrap justify-center align-center >
              <v-flex md5 class="text-xs-center margin" >
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="extra-sapling-header body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="extra-sapling-header body-2 accent--text">{{ $t('Lifetime') }}</div>
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_22 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_22 == 'card_right'"/>
    </v-flex>
     <v-flex xs12 md6 >
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_23 == 'availability'">
        <v-container grid-list-md text-xs-center class="pa-0 ma-0">
          <div class="pa-0 ma-0 d-flex align-center">
            <v-flex xs12 md5 class="pb-4 pb-md-0">
              <div v-if="widgetList.length">
                <div v-for="item in widgetList" :key="item.name">
                  <div class="card-title">{{ $t(item.name) }} (%)</div>
                  <v-progress-circular
                    :rotate="360"
                    :size="65"
                    :width="5"
                    :value="item.value"
                    color="#E9952A"
                  >
                    {{ widgetData[item.name] }}
                  </v-progress-circular>
                </div>
              </div>
            </v-flex>
            <v-divider class="custom-divider hidden-sm-and-down" vertical></v-divider>
            <v-divider class="custom-divider hidden-md-and-up" horizontal></v-divider>
            <v-flex xs12 md7 class="pa-0">
              <SimpleList :data="metric" />
            </v-flex>
          </div>
        </v-container>
      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_23 == 'carbon_footprint'">
        <div
          class="body-2 text-xs-center"
          :style="{
            height: '61px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2>
          <v-flex>
            <v-layout row wrap justify-center align-center>
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_23 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_23 == 'card_right'"/>
    </v-flex>
     <v-flex xs12 md6>
      <Card class="availability-card" v-if="selectedTabCompPosition.pos_24 == 'availability'">
        <v-container grid-list-md text-xs-center class="pa-0 ma-0">
          <div class="pa-0 ma-0 d-flex align-center">
            <v-flex xs12 md5 class="pb-4 pb-md-0">
              <div v-if="widgetList.length">
                <div v-for="item in widgetList" :key="item.name">
                  <div class="card-title">{{ $t(item.name) }} (%)</div>
                  <v-progress-circular
                    :rotate="360"
                    :size="65"
                    :width="5"
                    :value="item.value"
                    color="#E9952A"
                  >
                    {{ widgetData[item.name] }}
                  </v-progress-circular>
                </div>
              </div>
            </v-flex>
            <v-divider class="custom-divider hidden-sm-and-down" vertical></v-divider>
            <v-divider class="custom-divider hidden-md-and-up" horizontal></v-divider>
            <v-flex xs12 md7 class="pa-0">
              <SimpleList :data="metric" />
            </v-flex>
          </div>
        </v-container>
      </Card>
      <Card class="footprint-card" v-else-if="selectedTabCompPosition.pos_24 == 'carbon_footprint'">
        <div
          class="body-2 text-xs-center"
          :style="{
            height: '61px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
        >
          <img
            :src="require('@/assets/carbon_footprint/footprint.svg')"
            alt="battery"
            height="50px"
            width="50px"
            class="carbon-footprint__icon"
          />
          <span class="carbon-footprint__title">{{
            $t('CARBON FOOTPRINT')
          }}</span>
        </div>
        <v-divider class="custom-divider" />
        <v-layout row align-center wrap pa-3 pt-2>
          <v-flex>
            <v-layout row wrap justify-center align-center>
              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/co2.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('CO2 emission Reduced') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Today') }}</div>
                <div
                  v-if="!carbonFootprint.emission.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div class="body-2 accent--text">{{ $t('Lifetime') }}</div>
                  <div v-if="!carbonFootprint.emission.lifetime.data.includes('*')"
                    class="headline font-weight-bold text-xs-center carbon-footprint__value"
                  >
                    {{ carbonFootprint.emission.lifetime.data
                    }}
                    <span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                  </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.emission.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.emission.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.emission.lifetime.unit }}</span
                  >
                </div>
              </v-flex>

              <v-flex md5 class="text-xs-center">
                <img
                  :src="require(`@/assets/carbon_footprint/treeSapling.svg`)"
                  alt="battery"
                  height="50px"
                  width="50px"
                  class="carbon-footprint__icon"
                />
                <div class="body-2 text-xs-center carbon-footprint__title">
                  {{ $t('Equivalent Trees Planted') }}
                </div>
              </v-flex>
              <v-flex md3 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.today.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.today.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.today.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.today.unit }}</span
                  >
                </div>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <div
                  v-if="!carbonFootprint.sapling.lifetime.data.includes('*')"
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data
                  }}<span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
                <div
                  v-else
                  class="headline font-weight-bold text-xs-center carbon-footprint__value"
                >
                  {{ carbonFootprint.sapling.lifetime.data.split("*")[0].trim() }}x10<span
                    class="carbon-footprint__power"
                    >{{ carbonFootprint.sapling.lifetime.data.split("*")[1].split("^")[1] }}</span
                  ><span
                    class="body-2 font-weight-medium carbon-footprint__unit"
                  >
                    {{ carbonFootprint.sapling.lifetime.unit }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </Card>
      <DataCardSet :items="cardDataSetLeft" v-else-if="selectedTabCompPosition.pos_24 == 'card_left'"/>
      <DataCardSet :items="cardDataSetRight" v-else-if="selectedTabCompPosition.pos_24 == 'card_right'"/>
    </v-flex>
  </v-layout>
</template>

<script>
const DataCardSet = () => import("@/components/Plant Overview New/DataCardSet");
import SimpleList from "@/components/common/SimpleList.vue";

export default {
  props: {
    widgetList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    widgetData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    metric: {
      type: Array,
      default: function () {
        return []
      }
    },
    carbonFootprint: {
      type: Object,
      default: function () {
        return {
        emission: {
          today: {
            data: "-",
            unit: "Tons",
          },
          lifetime: {
            data: "-",
            unit: co2ComputedLifeTime.unit,
          },
        },
        sapling: {
          today: {
            data: "-",
            unit: "Nos",
          },
          lifetime: {
            data: "-",
            unit: "Nos",
          },
        },
      };
      }
    },
    cardDataSetLeft: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cardDataSetRight: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedTabCompPosition: {
      type: Object,
      default: function () {
        return {
          pos_21: "availability",
          pos_22: "carbon_footprint",
          pos_23: "card_left",
          pos_24: "card_right"
        }
      }
    }
  },
  components: {
    SimpleList,
    DataCardSet,
  }
};
</script>

<style scoped>
.extra-sapling-header {
  display: none;
}

.card-height-250 {
  min-height: 257px;
  max-height: 257px;
}

.card-title {
  font-size: 15px;
  text-align: center;
  padding: 10px 0 4px 0;
  margin-bottom: 5px;
}

.custom-divider {
  background-color: #334079;
}

.availability-card {
  height: 100%;
  border-radius: 6px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.footprint-card {
  height: 100%;
  border-radius: 6px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.carbon-footprint__value {
  color: #668cf6;
}

.carbon-footprint__power {
  font-size: 0.7em; /* Adjust font size for the superscript */
  vertical-align: super; /* Align the superscript text */
}

.carbon-footprint__unit {
  color: #aeaeae;
}


@media (max-width:510px) {
  .footprint-card {
    height: 100%;
  }
}

@media (max-width: 962px) and (min-width:645px) {
  .extra-sapling-header {
    display: block;
  }
}
 @media (max-width: 645px) and (min-width:450px) {
  .align {
    margin: 0px 50px !important;

  }

}
.theme--dark .carbon-footprint__title {
  color: #fff;
}

.theme--light .carbon-footprint__title {
  color: #000;
}

.theme--light .carbon-footprint__icon {
  filter: invert(48%) sepia(12%) saturate(463%) hue-rotate(179deg)
    brightness(98%) contrast(86%);
}
</style>